import deAdmin from "../locales/de/admin.json";
import deAdminEmail from "../locales/de/adminEmail.json";
import deAdminOverview from "../locales/de/adminOverview.json";
import deAuth from "../locales/de/auth.json";
import deAuthorMapping from "../locales/de/authorMapping.json";
import deBook from "../locales/de/book.json";
import deCalibreImport from "../locales/de/calibreImport.json";
import deCatalog from "../locales/de/catalog.json";
import deCommon from "../locales/de/common.json";
import deDevices from "../locales/de/devices.json";
import deEditing from "../locales/de/editing.json";
import deErrors from "../locales/de/errors.json";
import deInstanceSettings from "../locales/de/instanceSettings.json";
import deJobs from "../locales/de/jobs.json";
import deKindle from "../locales/de/kindle.json";
import deMetadataLookup from "../locales/de/metadataLookup.json";
import deRatings from "../locales/de/ratings.json";
import deReading from "../locales/de/reading.json";
import deSettings from "../locales/de/settings.json";
import deShelves from "../locales/de/shelves.json";
import deSuggestions from "../locales/de/suggestions.json";
import deUpload from "../locales/de/upload.json";
import enAdmin from "../locales/en/admin.json";
import enAdminEmail from "../locales/en/adminEmail.json";
import enAdminOverview from "../locales/en/adminOverview.json";
import enAuth from "../locales/en/auth.json";
import enAuthorMapping from "../locales/en/authorMapping.json";
import enBook from "../locales/en/book.json";
import enCalibreImport from "../locales/en/calibreImport.json";
import enCatalog from "../locales/en/catalog.json";
import enCommon from "../locales/en/common.json";
import enDevices from "../locales/en/devices.json";
import enEditing from "../locales/en/editing.json";
import enErrors from "../locales/en/errors.json";
import enInstanceSettings from "../locales/en/instanceSettings.json";
import enJobs from "../locales/en/jobs.json";
import enKindle from "../locales/en/kindle.json";
import enMetadataLookup from "../locales/en/metadataLookup.json";
import enRatings from "../locales/en/ratings.json";
import enReading from "../locales/en/reading.json";
import enSettings from "../locales/en/settings.json";
import enShelves from "../locales/en/shelves.json";
import enSuggestions from "../locales/en/suggestions.json";
import enUpload from "../locales/en/upload.json";

/**
 * Translation resources, one JSON file per namespace and language.
 * Namespaces follow the app areas: add a new namespace per feature
 * (e.g. `books`, `shelves`) instead of growing `common`.
 */
export const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    settings: enSettings,
    devices: enDevices,
    shelves: enShelves,
    reading: enReading,
    ratings: enRatings,
    admin: enAdmin,
    catalog: enCatalog,
    book: enBook,
    editing: enEditing,
    upload: enUpload,
    jobs: enJobs,
    instanceSettings: enInstanceSettings,
    metadataLookup: enMetadataLookup,
    calibreImport: enCalibreImport,
    kindle: enKindle,
    adminEmail: enAdminEmail,
    adminOverview: enAdminOverview,
    suggestions: enSuggestions,
    authorMapping: enAuthorMapping,
    errors: enErrors,
  },
  de: {
    common: deCommon,
    auth: deAuth,
    settings: deSettings,
    devices: deDevices,
    shelves: deShelves,
    reading: deReading,
    ratings: deRatings,
    admin: deAdmin,
    catalog: deCatalog,
    book: deBook,
    editing: deEditing,
    upload: deUpload,
    jobs: deJobs,
    instanceSettings: deInstanceSettings,
    metadataLookup: deMetadataLookup,
    calibreImport: deCalibreImport,
    kindle: deKindle,
    adminEmail: deAdminEmail,
    adminOverview: deAdminOverview,
    suggestions: deSuggestions,
    authorMapping: deAuthorMapping,
    errors: deErrors,
  },
} as const;

export const NAMESPACES = Object.keys(resources.en) as (keyof (typeof resources)["en"])[];
export const DEFAULT_NAMESPACE = "common";
